export enum SubscriptionTabs {
    PLAN_SELECTION = 'planSelectionTab',
    CONFIRM = 'confirmTab'
}